f = require 'effing'
React = require('react')
Promise = require 'bluebird'
t = require('views/internal/recup-with-helpers')('popover')
xtend = require 'xtend'
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: 'Popover'

  constructor: (props) ->
    super(props)

    @state = {
      title: ""
    }

  componentDidMount: ->
    @isStillMounted = true
    @updateTitle(@props)

  componentWillReceiveProps: (nextProps) ->
    @_titlePromise?.cancel()

    @updateTitle(nextProps)

  updateTitle: (props) ->
    # mod-no-header popovers don't have titles
    if !props.getViewTitle?
      return

    @_titlePromise =
      Promise
        .resolve(props.getViewTitle())
        .cancellable()
        .then (title) =>
          if @isStillMounted
            @setState({ title: title })
        .catch Promise.CancellationError, (->)

  componentWillUnmount: ->
    @isStillMounted = false
    @_titlePromise?.cancel()

  render: t.renderable ->
    { hideHeader, onBack, onClose, children } = @props

    t.div =>
      if !hideHeader
        t.div '.pop-over-header.js-pop-over-header', =>
          if onBack?
            t.a '.pop-over-header-back-btn.icon-sm.icon-back.is-shown',
              onClick: onBack
              href: "#"

          t.span '.pop-over-header-title', =>
            if @props.hasSafeViewTitle
              t.raw @state.title
            else
              t.text @state.title

          t.a '.pop-over-header-close-btn.icon-sm.icon-close',
            onClick: onClose
            href: "#"

      t.div =>
        props =
          className: 'pop-over-content js-pop-over-content u-fancy-scrollbar js-tab-parent'

        addClass = (addedClasses, classNames) -> _.chain(classNames?.split(" ")).union(addedClasses.split(" ")).value().join(" ")

        addClassesToReactElement = (classNames, reactElement) ->
          React.cloneElement reactElement, className: addClass("js-popover-pushed hide", reactElement.props.classNames)

        children =
          _.chain(children)
            .initial()
            .map(f(addClassesToReactElement, "js-popover-pushed hide"))
            .value()
            .concat(_.last(children))

        t.addElement React.createElement 'div', props, children



// WEBPACK FOOTER //
// ./app/scripts/views/lib/pop-over-react.coffee